import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import EmptyQuoteMessage from './EmptyQuoteMessage'
import withNavigateToTireSearchOrShowYmme from 'components/common/hoc/withNavigateToTireSearchOrShowYmme'
import { navigateToConfirmTireSize, getTireSizes } from 'components/VehicleConfigurator/actions.js'
import { getHasActiveVehicleWithTireSize, getHasActiveVehicleStatus } from 'selectors'
import { getYmmeVehicleId, getYmmeForConfirmTireSizePage } from 'components/common/hoc/withYmme/selectors'
import { YMME_NAME } from 'constant'
import { setVehicleDetails } from 'actions/confirmTireSize.js'
import { LOCAL_STORAGE_LAND_FROM, LOCAL_STORAGE_LAND_FROM_VALUE } from 'components/VehicleConfigurator/components/ConfirmTireSize/constants'

const mapStateToProps = state => {
  const ymmeName = YMME_NAME

  return {
    hasActiveVehicleWithTireSize: getHasActiveVehicleWithTireSize(state),
    vehicleId: getYmmeVehicleId(state, null, ymmeName),
    vehicleDetails: getYmmeForConfirmTireSizePage(state, { ymmeName }),
    hasActiveVehicle: getHasActiveVehicleStatus(state)
  }
}


const withContinueShoppingHandler = withHandlers({
  handleTireSearch: ({
    navigateToTireSearchOrShowYmme,
    navigateToConfirmTireSize,
    hasActiveVehicleWithTireSize,
    vehicleId,
    getTireSizes,
    vehicleDetails,
    setVehicleDetails,
    hasActiveVehicle
  }) => (e) => {
    if (!hasActiveVehicleWithTireSize && hasActiveVehicle) {
      setVehicleDetails(vehicleDetails)
      getTireSizes({ vehicleId }).then(() => { navigateToConfirmTireSize() })
      localStorage.setItem(LOCAL_STORAGE_LAND_FROM, LOCAL_STORAGE_LAND_FROM_VALUE)
    } else {
      e.preventDefault()
      navigateToTireSearchOrShowYmme({ searchByTireSizeForTrailer: true })
    }
  }
})

export default compose(
  connect(mapStateToProps, { navigateToConfirmTireSize, getTireSizes, setVehicleDetails }),
  withNavigateToTireSearchOrShowYmme,
  withContinueShoppingHandler
)(EmptyQuoteMessage)
